// categories view actions
export const CATEGORIES_VIEW_ERROR_DISSMISED = 'CATEGORIES_VIEW_ERROR_DISSMISED';
